<template>
  <div class="app-container cheliang-page">
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-select v-model="filters.community_id" filterable clearable placeholder="小区（可搜索）" size="mini">
          <el-option v-for="item in communityOptions" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-input v-model="filters.room_no" size="mini" clearable placeholder="房号" />
      </div>
      <div class="shaixuan-item">
        <el-input v-model="filters.space_no" size="mini" clearable placeholder="车位号" />
      </div>
      <div class="shaixuan-item">
        <el-input v-model="filters.phone" size="mini" clearable placeholder="业主手机号" />
      </div>
      <div class="shaixuan-item">
        <el-select v-model="filters.is_rent" clearable placeholder="租车位" size="mini" style="width:110px">
          <el-option label="是" :value="1" />
          <el-option label="否" :value="0" />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-select v-model="filters.is_parent_child" clearable placeholder="子母车位" size="mini" style="width:110px">
          <el-option label="是" :value="1" />
          <el-option label="否" :value="0" />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-button type="primary" size="mini" class="btn-primary-blue" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="mini" @click="resetFilters">重置</el-button>
        <el-button type="primary" size="mini" class="btn-primary-blue" icon="el-icon-refresh" @click="openSyncDrawer">同步</el-button>
      </div>
    </div>

    <div v-loading="listLoading" class="common-section-bg common-section-body table-wrap">
      <el-table :data="displayList" size="mini" style="width: 100%; min-height: 300px">
        <el-table-column prop="city" label="城市" width="80" />
        <el-table-column prop="project" label="小区" min-width="180" class-name="wrap-cell" />
        <el-table-column prop="space_no" label="车位编号" min-width="140" class-name="wrap-cell" />
        <el-table-column prop="owner" label="业主" min-width="120" class-name="wrap-cell" />
        <el-table-column prop="room_no" label="业主房号" min-width="140" class-name="wrap-cell" />
        <el-table-column prop="phone" label="手机号" width="120" />
        <el-table-column label="是否是租车状态" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="isRentStatus(scope.row) ? 'success' : 'info'" size="mini">{{ isRentStatus(scope.row) ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否是子母车位状态" width="140" align="center">
          <template slot-scope="scope">
            <el-tag :type="parentChildYes(scope.row) ? 'warning' : 'info'" size="mini">{{ parentChildYes(scope.row) ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sync_time" label="同步时间" min-width="160" class-name="wrap-cell" />
        <el-table-column label="操作" width="260" fixed="right" align="center">
          <template slot-scope="scope">
            <div class="table-action-btns">
              <el-button type="primary" size="mini" class="btn-primary-blue" @click="openDetailDrawer(scope.row)">详情</el-button>
              <el-button type="danger" size="mini" class="btn-edit-green" @click="openRentDialog(scope.row)">租车位</el-button>
              <el-button type="danger" size="mini" class="btn-edit-green" @click="openParentChildDialog(scope.row)">子母车位</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="getList"
      />
    </div>

    <el-drawer
      custom-class="custom-drawer"
      :visible.sync="detailDrawerVisible"
      :close-on-press-escape="false"
      :wrapper-closable="false"
      :show-close="false"
      size="640px"
    >
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">车位详情</div>
          <i class="el-icon-circle-close close-btn pointer" @click="detailDrawerVisible = false" />
        </div>
      </template>
      <div v-if="currentRow" v-loading="detailLoading" class="custom-content vd-panel">
        <div class="vd-hero">
          <div class="vd-hero-main">
            <div class="vd-hero-title">{{ currentRow.space_no || '—' }}</div>
            <div class="vd-hero-sub">{{ currentRow.project || '—' }}</div>
            <div class="vd-hero-tags">
              <el-tag size="small" :type="isRentStatus(currentRow) ? 'warning' : 'info'">
                {{ isRentStatus(currentRow) ? '租车位' : '非租车位' }}
              </el-tag>
              <el-tag size="small" :type="parentChildYes(currentRow) ? 'warning' : 'info'">
                {{ parentChildYes(currentRow) ? '子母车位' : '非子母车位' }}
              </el-tag>
            </div>
          </div>
          <div class="vd-hero-side">
            <div class="vd-hero-meta">
              <span class="vd-hero-label">业主</span>
              <span class="vd-hero-value">{{ currentRow.owner || '—' }}</span>
            </div>
            <div class="vd-hero-meta">
              <span class="vd-hero-label">手机</span>
              <span class="vd-hero-value">{{ currentRow.phone || '—' }}</span>
            </div>
          </div>
        </div>

        <div class="vd-section">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>车位信息</span>
          </div>
          <div class="vd-grid">
            <div class="vd-cell"><span class="vd-lab">小区</span><span class="vd-val">{{ currentRow.project || '—' }}</span></div>
            <div class="vd-cell"><span class="vd-lab">车位编号</span><span class="vd-val">{{ currentRow.space_no || '—' }}</span></div>
            <div class="vd-cell"><span class="vd-lab">业主房号</span><span class="vd-val">{{ currentRow.room_no || '—' }}</span></div>
            <div class="vd-cell"><span class="vd-lab">业主</span><span class="vd-val">{{ currentRow.owner || '—' }}</span></div>
            <div class="vd-cell"><span class="vd-lab">手机号</span><span class="vd-val">{{ currentRow.phone || '—' }}</span></div>
            <div class="vd-cell"><span class="vd-lab">租车状态</span><span class="vd-val">{{ isRentStatus(currentRow) ? '是' : '否' }}</span></div>
            <div class="vd-cell"><span class="vd-lab">子母车位</span><span class="vd-val">{{ parentChildYes(currentRow) ? '是' : '否' }}</span></div>
          </div>
        </div>

        <div class="vd-section">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>有效期</span>
          </div>
          <div class="vd-expire-grid vd-expire-grid-single">
            <div class="vd-expire-card">
              <div class="vd-expire-label">车位费有效期</div>
              <div class="vd-expire-value-row">
                <span class="vd-expire-value">{{ currentRow.fee_expire_date || '—' }}</span>
                <el-button
                  type="primary"
                  size="mini"
                  class="btn-primary-blue"
                  icon="el-icon-refresh"
                  :loading="syncingParkingFee"
                  :disabled="!currentRow.id"
                  @click="syncParkingFee"
                >同步物业费</el-button>
              </div>
              <p class="vd-expire-tip">从天问同步车位物业服务费，并按有效期更新本车位绑定的海康/捷卫士车辆</p>
            </div>
          </div>
        </div>

        <div class="vd-section vd-section-last">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>绑定车辆</span>
            <span class="vd-section-count">{{ (currentRow.vehicles || []).length }}</span>
          </div>
          <el-table :data="currentRow.vehicles || []" size="mini" class="vd-table" stripe style="width: 100%">
            <el-table-column prop="plate" label="车牌号" width="110" />
            <el-table-column prop="owner" label="车主" width="80" show-overflow-tooltip />
            <el-table-column prop="source" label="来源" width="80" />
            <el-table-column prop="vehicle_type" label="类型" width="80" />
            <el-table-column prop="in_garage" label="在库" width="60" align="center" />
            <el-table-column prop="expire_date" label="有效期" min-width="105" />
          </el-table>
          <el-empty v-if="!(currentRow.vehicles || []).length" description="暂无绑定车辆" :image-size="80" />
        </div>
      </div>
    </el-drawer>

    <el-drawer
      custom-class="custom-drawer"
      :visible.sync="syncDrawerVisible"
      :close-on-press-escape="false"
      :wrapper-closable="false"
      :show-close="false"
      size="600px"
      :before-close="handleDrawerClose"
    >
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">车位信息同步</div>
          <i class="el-icon-circle-close close-btn pointer" @click="closeSyncDrawer" />
        </div>
      </template>
      <div class="custom-content sync-drawer-body vd-panel">
        <div class="vd-section">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>选择小区同步</span>
          </div>
          <div class="sync-action-row">
            <el-select v-model="syncCommunityId" filterable clearable placeholder="请选择小区（可搜索）" size="mini" style="flex:1">
              <el-option v-for="item in communityOptions" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
            <el-button type="primary" size="mini" class="btn-primary-blue" :loading="syncing" :disabled="!syncCommunityId || syncing" @click="startSync">开始同步</el-button>
          </div>
        </div>
        <div class="vd-section">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>同步进度</span>
          </div>
          <div v-if="syncing || syncProgress.total > 0" class="vd-progress-box">
            <div class="progress-text">
              <span>总数：{{ syncProgress.total }}</span>
              <span>已同步：{{ syncProgress.synced }}</span>
              <span>{{ syncProgressPercent }}%</span>
            </div>
            <el-progress :percentage="syncProgressPercent" :status="syncing ? null : 'success'" />
            <p class="progress-tip">{{ syncing ? '同步进行中…' : '同步已完成' }}</p>
          </div>
          <el-empty v-else description="请选择小区并开始同步" :image-size="80" />
        </div>
        <div class="vd-section vd-section-last">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>已同步小区列表</span>
          </div>
          <el-table :data="syncHistory" size="mini" class="vd-table" stripe style="width: 100%" max-height="280">
            <el-table-column prop="project" label="小区" min-width="100" show-overflow-tooltip />
            <el-table-column prop="total" label="总数" width="65" align="center" />
            <el-table-column prop="synced" label="已同步" width="70" align="center" />
            <el-table-column prop="start_time" label="开始时间" width="145" show-overflow-tooltip />
            <el-table-column prop="end_time" label="结束时间" width="145" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.end_time || '—' }}</template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="75" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === '已完成' ? 'success' : (scope.row.status === '失败' ? 'danger' : 'warning')" size="mini">{{ scope.row.status }}</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>

    <el-dialog
      custom-class="chechang-form-dialog"
      title="租车位管理"
      :visible.sync="rentDialogVisible"
      width="560px"
      append-to-body
    >
      <div class="chechang-dialog-body vd-panel">
        <div class="vd-section vd-section-last vd-form-panel">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>租车信息</span>
          </div>
          <el-form label-width="110px">
            <el-form-item label="车位编号"><el-input v-model="rentForm.space_no" disabled /></el-form-item>
            <el-form-item label="租车位状态">
              <el-select v-model="rentForm.status" style="width:100%">
                <el-option label="已租" value="已租" />
                <el-option label="空闲" value="空闲" />
              </el-select>
            </el-form-item>
            <el-form-item label="租户姓名"><el-input v-model="rentForm.tenant_name" /></el-form-item>
            <el-form-item label="租户手机号"><el-input v-model="rentForm.tenant_phone" /></el-form-item>
            <el-form-item label="租户身份证号"><el-input v-model="rentForm.tenant_id_card" /></el-form-item>
            <el-form-item label="租期开始">
              <el-date-picker v-model="rentForm.rent_start" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
            <el-form-item label="租期结束">
              <el-date-picker v-model="rentForm.rent_end" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="rentDialogVisible = false">取消</el-button>
        <el-button type="primary" class="btn-primary-blue" :loading="saveLoading" @click="saveRent">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      custom-class="chechang-form-dialog"
      title="子母车位管理"
      :visible.sync="parentChildDialogVisible"
      width="560px"
      append-to-body
    >
      <div class="chechang-dialog-body vd-panel">
        <div class="vd-section vd-section-last vd-form-panel">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>子母车位配置</span>
          </div>
          <el-form label-width="130px">
            <el-form-item label="车位编号"><el-input v-model="parentChildForm.space_no" disabled /></el-form-item>
            <el-form-item label="是否子母车位">
              <el-select v-model="parentChildForm.is_parent_child" style="width:100%" @change="onParentChildFlagChange">
                <el-option label="是" value="是" />
                <el-option label="否" value="否" />
              </el-select>
            </el-form-item>
            <el-form-item label="关联车位编号">
              <el-input
                v-model="parentChildForm.related_spaces"
                :disabled="parentChildForm.is_parent_child !== '是'"
                placeholder="如 CW-1-1-001/CW-1-1-002"
              />
            </el-form-item>
            <el-form-item label="可进入车辆数">
              <el-input-number
                v-model="parentChildForm.max_cars"
                :min="parentChildEnterMin"
                :max="10"
                :disabled="parentChildForm.is_parent_child !== '是'"
              />
              <p class="upload-tip">非子母车位可进入 1 辆且不可改；子母车位默认可进入 2 辆，可更改！</p>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="parentChildDialogVisible = false">取消</el-button>
        <el-button type="primary" class="btn-primary-blue" :loading="saveLoading" @click="saveParentChild">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import chechangParkingSpace from '@/api/tianzheng/chechangParkingSpace'

const defaultFilters = () => ({
  community_id: '',
  room_no: '',
  space_no: '',
  phone: '',
  is_rent: '',
  is_parent_child: ''
})

export default {
  name: 'ParkingSpaceSync',
  components: { Pagination },
  data() {
    return {
      listLoading: false,
      detailLoading: false,
      saveLoading: false,
      communityOptions: [],
      displayList: [],
      total: 0,
      listQuery: { page: 1, size: 10 },
      filters: defaultFilters(),
      detailDrawerVisible: false,
      syncDrawerVisible: false,
      rentDialogVisible: false,
      parentChildDialogVisible: false,
      currentRow: null,
      rentForm: {},
      parentChildForm: { max_cars: 1, is_parent_child: '否' },
      syncCommunityId: '',
      syncing: false,
      syncingParkingFee: false,
      syncProgress: { total: 0, synced: 0 },
      syncHistory: [],
      syncTimer: null,
      currentTaskId: null
    }
  },
  computed: {
    syncProgressPercent() {
      if (!this.syncProgress.total) return 0
      return Math.min(100, Math.round((this.syncProgress.synced / this.syncProgress.total) * 100))
    },
    parentChildEnterMin() {
      return this.parentChildForm.is_parent_child === '是' ? 2 : 1
    }
  },
  created() {
    this.loadCommunityOptions()
    this.getList()
  },
  beforeDestroy() {
    this.clearSyncTimer()
  },
  methods: {
    loadCommunityOptions() {
      chechangParkingSpace.communitySelect().then(res => {
        if (res.code === 200) {
          this.communityOptions = res.result || []
        }
      })
    },
    getList() {
      this.listLoading = true
      chechangParkingSpace.list({
        page: this.listQuery.page,
        size: this.listQuery.size,
        ...this.filters
      }).then(res => {
        this.listLoading = false
        if (res.code === 200) {
          this.displayList = res.result.list || []
          this.total = res.result.total || 0
        }
      }).catch(() => { this.listLoading = false })
    },
    handleSearch() {
      this.listQuery.page = 1
      this.getList()
    },
    resetFilters() {
      this.filters = defaultFilters()
      this.listQuery.page = 1
      this.getList()
    },
    isRentStatus(row) {
      return row.rent && row.rent.status === '已租'
    },
    parentChildYes(row) {
      if (row.parent_child && row.parent_child.is_parent_child) {
        return row.parent_child.is_parent_child === '是'
      }
      return row.is_parent_child === 1
    },
    openDetailDrawer(row) {
      this.detailDrawerVisible = true
      this.detailLoading = true
      this.syncingParkingFee = false
      this.currentRow = { ...row }
      chechangParkingSpace.detail({ id: row.id }).then(res => {
        this.detailLoading = false
        if (res.code === 200) {
          this.currentRow = res.result
        }
      }).catch(() => { this.detailLoading = false })
    },
    syncParkingFee() {
      if (!this.currentRow || !this.currentRow.id) return
      this.$confirm('将从天问同步该车位物业服务费，并按有效期更新绑定车辆有效期，是否继续？', '同步物业费', {
        type: 'warning',
        confirmButtonText: '确定同步',
        cancelButtonText: '取消'
      }).then(() => {
        this.syncingParkingFee = true
        chechangParkingSpace.syncParkingFee({ id: this.currentRow.id }).then(res => {
          this.syncingParkingFee = false
          if (res.code !== 200) {
            this.$message.error(res.message || res.msg || '同步失败')
            return
          }
          const result = res.result || {}
          if (result.fee_expire_date) {
            this.$set(this.currentRow, 'fee_expire_date', result.fee_expire_date)
          }
          if (result.vehicles) {
            this.$set(this.currentRow, 'vehicles', result.vehicles)
          }
          if (result.remote_warning) {
            this.$message.warning(result.remote_warning)
          } else {
            const expire = result.fee_expire_date || '—'
            const count = result.updated_vehicle_count != null ? result.updated_vehicle_count : 0
            this.$message.success(`同步成功，车位费有效期：${expire}，已更新车辆 ${count} 辆`)
          }
        }).catch(() => {
          this.syncingParkingFee = false
        })
      }).catch(() => {})
    },
    openSyncDrawer() {
      this.syncDrawerVisible = true
      this.loadSyncHistory()
    },
    loadSyncHistory() {
      chechangParkingSpace.syncHistory({ page: 1, size: 20 }).then(res => {
        if (res.code === 200) {
          this.syncHistory = res.result.list || []
        }
      })
    },
    closeSyncDrawer() {
      if (this.syncing) {
        this.handleDrawerClose(() => { this.syncDrawerVisible = false })
        return
      }
      this.syncDrawerVisible = false
    },
    handleDrawerClose(done) {
      if (this.syncing) {
        this.$confirm('同步进行中，确定关闭？', '提示', { type: 'warning' })
          .then(() => {
            this.clearSyncTimer()
            this.syncing = false
            done()
          })
          .catch(() => {})
        return
      }
      done()
    },
    startSync() {
      if (!this.syncCommunityId) {
        this.$message.warning('请选择小区')
        return
      }
      this.clearSyncTimer()
      this.syncing = true
      this.syncProgress = { total: 0, synced: 0 }
      chechangParkingSpace.sync({ community_id: this.syncCommunityId }).then(res => {
        if (res.code !== 200) {
          this.syncing = false
          this.$message.error(res.message || '同步失败')
          return
        }
        this.currentTaskId = res.result.task_id
        this.pollSyncProgress()
        this.syncTimer = setInterval(() => { this.pollSyncProgress() }, 3000)
      }).catch(() => { this.syncing = false })
    },
    pollSyncProgress() {
      if (!this.currentTaskId) return
      chechangParkingSpace.syncProgress({ task_id: this.currentTaskId }).then(res => {
        if (res.code !== 200) return
        const data = res.result
        this.syncProgress = { total: data.total, synced: data.synced }
        if (data.status === 'completed' || data.status === 'failed') {
          this.finishSync(data.status === 'failed')
        }
      })
    },
    finishSync(failed) {
      this.clearSyncTimer()
      this.syncing = false
      this.loadSyncHistory()
      this.getList()
      if (failed) {
        this.$message.error('同步失败，请查看同步历史')
      } else {
        this.$message.success('车位信息同步完成')
      }
    },
    clearSyncTimer() {
      if (this.syncTimer) {
        clearInterval(this.syncTimer)
        this.syncTimer = null
      }
    },
    openRentDialog(row) {
      this.currentRow = row
      const rent = row.rent || {}
      this.rentForm = {
        parking_space_id: row.id,
        space_no: row.space_no,
        status: rent.status || '空闲',
        tenant_name: rent.tenant || '',
        tenant_phone: rent.phone || '',
        tenant_id_card: rent.id_card || '',
        rent_start: rent.rent_start || '',
        rent_end: rent.rent_end || ''
      }
      this.rentDialogVisible = true
    },
    openParentChildDialog(row) {
      this.currentRow = row
      const pc = row.parent_child || {}
      const isYes = (pc.is_parent_child || '否') === '是'
      let maxCars = parseInt(pc.max_cars, 10)
      if (!Number.isFinite(maxCars)) {
        maxCars = isYes ? 2 : 1
      }
      if (isYes) {
        maxCars = Math.min(10, Math.max(2, maxCars))
      } else {
        maxCars = 1
      }
      this.parentChildForm = {
        parking_space_id: row.id,
        space_no: row.space_no,
        is_parent_child: isYes ? '是' : '否',
        related_spaces: isYes ? (pc.related_spaces || '') : '',
        max_cars: maxCars
      }
      this.parentChildDialogVisible = true
    },
    onParentChildFlagChange(val) {
      if (val === '是') {
        const current = parseInt(this.parentChildForm.max_cars, 10)
        this.parentChildForm.max_cars = Number.isFinite(current) && current >= 2
          ? Math.min(10, current)
          : 2
      } else {
        this.parentChildForm.max_cars = 1
        this.parentChildForm.related_spaces = ''
      }
    },
    saveRent() {
      this.saveLoading = true
      chechangParkingSpace.rentSave(this.rentForm).then(res => {
        this.saveLoading = false
        if (res.code === 200) {
          this.rentDialogVisible = false
          this.$message.success('租车位信息已保存')
          this.getList()
        }
      }).catch(() => { this.saveLoading = false })
    },
    saveParentChild() {
      this.saveLoading = true
      chechangParkingSpace.parentSave({
        parking_space_id: this.parentChildForm.parking_space_id,
        is_parent_child: this.parentChildForm.is_parent_child === '是' ? 1 : 0,
        related_spaces: this.parentChildForm.related_spaces,
        max_cars: this.parentChildForm.max_cars
      }).then(res => {
        this.saveLoading = false
        if (res.code === 200) {
          this.parentChildDialogVisible = false
          this.$message.success('子母车位信息已保存')
          this.getList()
        }
      }).catch(() => { this.saveLoading = false })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/page.scss';

.upload-tip {
  margin: 8px 0 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

::v-deep .wrap-cell .cell {
  white-space: normal !important;
  word-break: break-all;
  line-height: 1.4;
  overflow: visible;
  text-overflow: unset;
}
</style>

<style lang="scss">
@import '../styles/drawer-patch.scss';
</style>
